module.exports = __webpack_public_path__ + "img/icon_logo.bee6abb8.png";